// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-2519970f] {\n  display: flex;\n}\n.search_btn[data-v-2519970f] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
